// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2edHJ","inputWrap":"CustomTip_inputWrap__3kGqx"};